<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>小程序设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">小程序设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="show = true" v-if="type ==='firstPage' && list.length<1">
          <span>添加首页设置</span>
        </div>
        <div class="htb-item" @click="show = true" v-if="type === 'topIcon'">
          <span>添加小程序顶部设置</span>
        </div>
        <div class="htb-item" @click="show = true" v-if="type === 'hotActivity'">
          <span>添加热门活动设置</span>
        </div>
        <div class="htb-item" @click="show = true" v-if="type === 'exhibitionService'">
          <span>添加展会服务设置</span>
        </div>
        <div class="htb-item" @click="show = true" v-if="type === 'mettings'">
          <span>添加会议论坛设置</span>
        </div>
        <div class="htb-item" @click="show = true" v-if="type === 'topButton'">
          <span>添加首页按钮设置</span>
        </div>
        <div class="htb-item" @click="show = true" v-if="type === 'test'">
          <span>添加测试</span>
        </div>
      </div>
    </div>
    <div style="padding:24px 0 0 24px;">
      <RadioGroup v-model="type" type="button" @on-change="typeChange">
        <Radio label="firstPage">首页</Radio>
        <Radio label="topButton">首页按钮</Radio>
        <Radio label="topIcon">顶部</Radio>
        <Radio label="hotActivity">热门活动</Radio>
        <Radio label="exhibitionService">展会服务</Radio>
        <Radio label="mettings">会议论坛</Radio>
        <!-- <Radio label="test">测试</Radio> -->
      </RadioGroup>
    </div>
    <div class="host-ad">
      <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false" no-data-text="暂无数据">
        <template slot-scope="{ row, index }" slot="name">{{ row.name }}</template>
        <template slot-scope="{ row, index }" slot="pictureUrl">
          <div style="display:flex;align-items:center;padding:10px 0;">
            <img style="width:72px; margin: 0 auto; cursor: pointer;" :src="row.pictureUrl" @click="visible = true; imgurl = row.pictureUrl;" />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="type">
          <span v-if="row.type === 'firstPage'">首页</span>
          <span v-if="row.type === 'topIcon'">顶部icon</span>
          <span v-if="row.type === 'hotActivity'">热门活动</span>
          <span v-if="row.type === 'exhibitionService'">展会服务</span>
          <span v-if="row.type === 'mettings'">会议论坛</span>
          <span v-if="row.type === 'topButton'">首页按钮</span>
        </template>
        <template slot-scope="{ row, index }" slot="skipType">
          <span v-if="row.skipType === 'normalUrl'">外链</span>
          <span v-if="row.skipType === 'wechatUrl'">小程序链接</span>
          <span v-if="row.skipType === 'content'">富文本</span>
          <span v-if="row.skipType === 'otherWeChatUrl'">跳转其它小程序</span>
        </template>
        <template slot-scope="{ row, index }" slot="skipContent">
          <Button type="primary" ghost v-if="row.skipType === 'content'" @click="showHandle(row)">显示富文本</Button>
          <span v-else>{{ row.skipContent }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="showIndex">{{ row.showIndex }}</template>
        <template slot-scope="{ row, index }" slot="isEnable">
          <iSwitch :value="row.isEnable" size="large" @on-change="changeSwitch($event, row)">
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </iSwitch>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;" @click="setShow(row)">编辑</span>
          <span style="display: inline-block;padding: 0 5px;">|</span>
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>

      <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;padding-top: 20px">
        <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
      </div>
      <iModal title="查看图片" v-model="visible" class-name="ad-home-modal" width="600px" footer-hide>
        <div style="width:100%;height:100%;">
          <img style="width:100%;" :src="imgurl" />
        </div>
      </iModal>

    </div>
    <commonMiniEdit :type="type" :show="editShow" v-if="editShow" :editInfo="editInfo" @finish="init()" @close="editShow = false; editInfo = null; $emit('editFinish');" />
    <commonMiniAdd :type="type" :show="show" @finish="init()" @close="show = false;" />
    <iModal title="内容" v-model="showRich" :styles="{top: '20px'}">
      <div v-html="richTxt"></div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import commonMiniAdd from "../components/common-mini-add.vue";
import commonMiniEdit from "../components/common-mini-edit.vue";

export default {
  name: "common-mini",
  data () {
    return {
      type: 'firstPage',
      showRich: false,
      richTxt: '',
      show: false,
      list: [],
      columns1: [
        {
          title: "名称",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "图片",
          slot: "pictureUrl",
          key: "pictureUrl",
          align: "center"
        },
        {
          title: "功能模块",
          slot: "type",
          key: "type",
          align: "center"
        },
        {
          title: "链接类型",
          slot: "skipType",
          key: "skipType",
          align: "center"
        },
        {
          title: "跳转链接",
          slot: "skipContent",
          key: "skipContent",
          align: "center"
        },
        {
          title: "显示顺序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "是否显示",
          slot: "isEnable",
          key: "isEnable",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      visible: false,
      imgurl: "",
      editShow: false,
      editInfo: null,
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
    }
  },
  computed: {
    option () {
      return {
        type: this.type, // firstPage/topIcon/hotActivity/exhibitionService 首页/顶部icon/热门活动/展会服务 
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }
    }
  },
  methods: {
    ...mapActions({
      getWeChatSkipSettleByPage: "hostWeChatSkipSettle/getWeChatSkipSettleByPage",
      delWeChatSkipSettleById: "hostWeChatSkipSettle/delWeChatSkipSettleById",
      editWeChatSkipSettleInfo: "hostWeChatSkipSettle/editWeChatSkipSettleInfo"
    }),
    async init () {
      let list = await this.getWeChatSkipSettleByPage(this.option);
      console.log('list', list);
      this.list = list.items;
      this.totalCount = list.totalCount;
    },
    setShow (item) {
      this.editInfo = item;
      this.editShow = true;
    },
    async delItem (item) {
      let result = await this.delWeChatSkipSettleById(item.id);
      if (result) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    changePage (e) {
      this.pageIndex = e;
      this.init();

    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },

    typeChange (e) {
      console.log('typeChange', e);
      this.editInfo = null;
      this.init();
    },
    changeSwitch (e, data) {
      this.edit(data);
    },
    async edit (item) {
      const req = {
        Id: item.id,
        SetValues: { IsEnable: !item.isEnable }
      };
      let result = await this.editWeChatSkipSettleInfo(req);
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    showHandle (row) {
      this.showRich = true;
      this.richTxt = row.skipContent;
    }
  },
  created () {
    this.init();
  },
  components: {
    commonMiniEdit,
    commonMiniAdd
  }
}
</script>

<style lang="scss" scoped>
.host-ad {
  min-width: 600px;
  padding: 30px 30px 100px 30px;
}
</style>
<style lang="scss">
.ad-home-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .ad-home-modal {
    display: block;

    .ivu-modal {
      top: 150px;
    }
  }
}
</style>